/**
 * 邮箱
 * @param {*} s
 */
export function isEmail(s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone(s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 正整数验证
 * @param {*} s
 */
export function isNumber(s) {
  // /^([1-9]\d*|[0]{1,1})$/ 包含0的
  // /^[1-9]+\d*$/ 不包含0的
  return /^([1-9]\d*|[0]{1,1})$/.test(s)
}

export function iszzNumber(s) {
  // /^([1-9]\d*|[0]{1,1})$/ 包含0的
  // /^[1-9]+\d*$/ 不包含0的
  return /^[1-9]+\d*$/.test(s)
}

/**
 * 保留两位小数
 * @param {*} s
 */
export function isfNumber(s) {
  return /^(([1-9]{1}\d*)|(0{1}))(\.\d{2})$/.test(s)
}


/**
 * 验证登录密码
 * @param {*} s
 */
export function isLoginpsw(s) {
  return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,8}$/.test(s)
}

/**
 * 验证订单号(数字)
 * @param {*} s
 */
export function istro(s) {
  return /^[0-9]*$/.test(s)
}

//时间戳转换时间
export function formatDate1(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
};

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
};

/**
 * 修改大数据格式(万位隔开)
 * @param {*} s
 */
// export function stateCome(s) {
//   // return /^[0-9]*$/.test(s)
//   if (s == undefined || s == null || s == "") {
//     return "0";
//   } else {
//     if (/\S{5}/.test(s.toString())) {
//       return s.toString().replace(/(\d)(?=(\d{4})+(?!\d))/g, "$1,");
//     } else {
//       return s;
//     }
//   }
// }

export function stateCome(input) {  
  // 正则表达式解释：  
  // ^              - 字符串开始  
  // (-)?           - 可选的负号  
  // (\d{1,3}(,)?) - 一组1到3位数字，后面可能跟着一个逗号  
  // (\d{3},)*     - 0或多个组，每组包含3位数字和一个逗号  
  // \d{1,3}       - 最后一组1到3位数字（末尾不需要逗号）  
  // $              - 字符串结束  
  if(input == undefined || input == null || input == ""){
    return "0";
  }else{
    return input.toLocaleString('en-US');  
  }
 
}  

/**
 * 秒换成分
 * @param {*} value
 */
export function sToM(value) {
  if (value == undefined || value == null || value == "") {
    return value = 0
  } else {
    value = (value / 60).toFixed(1)
    return value
  }


}

/**
 * 分换成时分
 * @param {*} value
 */
export function sToMs(value) {
  if (value == undefined || value == null || value == "") {
    return value = 0
  } else {
    let hours = parseInt(value / 60) % 24
    let minutes = parseInt(value) % 60
    return `${hours}h${minutes}m`
  }


}

/**
 * 数字转化
 * @param {*} value
 */
export function isnum(value) {
  // console.log(localStorage.getItem('locale'))
  if (localStorage.getItem('locale') == 'hi') {
    if (value == "NaN" || value == undefined || value == null || value == "") {
      value = "0"
      return value
    } else if ((value / 10000) >= 1 && (value / 1000000) < 1) {
      //					value = (value/10000).toFixed(0)+"万"
      value = Math.floor((value / 1000) * 100) / 100 + "k"
      return value
    }
    else if ((value / 1000000) >= 1) {
      value = (Math.floor((value / 1000000) * 100) / 100) + "m"
      return value
    }
    else {
      return value
    }
  } else {
    if (value == "NaN" || value == undefined || value == null || value == "") {
      value = "0"
      return value
    } else if ((value / 10000) >= 1 && (value / 100000000) < 1) {
      //					value = (value/10000).toFixed(0)+"万"
      // value = Math.floor((value / 10000) * 100) / 100 + "万"
      return value
    }
    else if ((value / 100000000) >= 1) {
      //					value = (value/100000000).toFixed(1)+"亿"
      // value = (Math.floor((value / 100000000) * 100) / 100) + "亿"
      return value

    }
    else {
      return value
    }
  }




}

/**
 * 是否为空
 * @param {*} value
 */
export function isnull(value) {
  if (value == "NaN" || value == undefined || value == null) {
    value = ""
    return value
  } else {
    return value
  }
}




